import axios from 'axios'
import rutas from '@/assets/utils/rutas.json'

const API = `${rutas.axios}api`

export const asignacionPaquetesService = {
  async crearAsignacionPaquete(variables) {
    const mutation = `
      mutation CrearAsignacionPaquete(
        $id_paciente: Int!,
        $id_paquete: Int!,
        $atenciones_medica: JSON,
        $imagenes: JSON,
        $procedimientos: JSON,
        $laboratorio: JSON,
        $terapias: JSON
      ) {
        crearAsignacionPaquete(
          id_paciente: $id_paciente,
          id_paquete: $id_paquete,
          atenciones_medica: $atenciones_medica,
          imagenes: $imagenes,
          procedimientos: $procedimientos,
          laboratorio: $laboratorio,
          terapias: $terapias
        ) {
          status
          message
          id
        }
      }
    `

    const sanitizedVariables = {
      ...variables,
      atenciones_medica: variables.atenciones_medica || [],
      imagenes: variables.imagenes || [],
      procedimientos: variables.procedimientos || [],
      laboratorio: variables.laboratorio || [],
      terapias: variables.terapias || [],
    }

    const { data } = await axios.post(API, {
      query: mutation,
      variables: sanitizedVariables,
    })

    if (Array.isArray(data?.errors) && data.errors.length) {
      const [firstError] = data.errors
      const error = new Error(firstError?.message || 'Error en crearAsignacionPaquete')
      error.graphQLErrors = data.errors
      throw error
    }

    return data?.data?.crearAsignacionPaquete || null
  },
}

export default asignacionPaquetesService
